import React, { useState, useEffect } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ALL_COUNSELLING_THEME } from "../../GraphQL/Queries";
import { CHANGE_THEME_STATUS } from "../../GraphQL/Mutations";
import MaterialTable from "material-table";
import {
  GeneralStyleSurveyCategory,
  ContentLoaderSurveyCategory,
  TableConvention,
  useStylesSurveyCategories,
} from "./ThemeCategories.styled";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import { Row, Col } from "react-bootstrap";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import PortalModal from "../../Portals";
import { NotificationManager } from "react-notifications";
import ModalConfirmAction from "../ModalConfirmAction/ModalConfirmAction";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import TablePagination from "@material-ui/core/TablePagination";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import NoRecord from "../NoRecord/NoRecord";
import { AntSwitch } from "../../helpers/antSwitch";
import { theme as themeConfig } from "../../themes/themes";
import moment from "moment";
import { clientWellness } from "../../App";

const ThemeCategories = ({
  formTrigger,
  setFormTrigger,
  setupdateData,
  showCards,
  setShowCards,
  searchBy,
}) => {
  const classes = useStylesSurveyCategories();
  const [user] = useState(getStateLoginComplete());
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [showLoader, setshowLoader] = useState(false);
  const [reloadRender, setreloadRender] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [updateState] = useMutation(CHANGE_THEME_STATUS, {
    client: clientWellness,
  });
  const [categories, setCategories] = useState([]);
  const [allPages, setAllPages] = useState(null);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPageOptions] = useState([5, 10, 25]);
  const [columnThemeCategories, setColumnThemeCategories] = useState([]);
  const [runQueryAllThemes, { loading, error }] = useLazyQuery(
    ALL_COUNSELLING_THEME,
    {
      fetchPolicy: "network-only",
      client: clientWellness,
      onCompleted: (data) => {
        setAllPages(data.allCounsellingThemes?.totalCount);
        if (data.allCounsellingThemes.pageInfo.hasNextPage === true) {
          setEndCursor(data.allCounsellingThemes.pageInfo.endCursor);
        }
        if (data.allCounsellingThemes.pageInfo.hasPreviousPage === true) {
          setStartCursor(data.allCounsellingThemes.pageInfo.startCursor);
        }
        const allCounsellingThemes = data?.allCounsellingThemes.nodes
          .map((ct) => ({ ...ct }))
          .filter((el) => el.recordState !== "Deleted");
        setCategories(allCounsellingThemes);
      },
    }
  );

  useEffect(() => {
    setColumnThemeCategories([
      {
        title: "ID",
        field: "idCounsellingTheme",
        type: "string",
      },
      {
        title: "Description",
        field: "themeName",
        type: "string",
      },
      {
        title: "Creation Date",
        type: "createDate",
        render: (rowData) => {
          return <>{moment(rowData?.createDate).format("YYYY-MM-DD")}</>;
        },
      },
      {
        title: "Created by",
        field: "createUser",
        type: "string",
      },
      {
        title: "Disable",
        field: "recordState",
        type: "string",
        cellStyle: {
          padding: "0px 16px",
        },
        render: (rowData) => {
          return (
            <FormControlLabel
              control={
                <AntSwitch
                  size="small"
                  checked={
                    rowData?.recordState.toUpperCase() === "ACTIVE"
                      ? true
                      : false
                  }
                  onChange={() => toggleChecked(rowData)}
                />
              }
            />
          );
        },
      },
      {
        title: "Action",
        field: "internal_action",
        sorting: false,
        cellStyle: {
          padding: "0px 16px",
        },
        render: (rowData) =>
          rowData && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Edit">
                  <IconButton
                    className={classes.active}
                    onClick={() => {
                      setAnchorEl(null);
                      setAnchorSelected(null);
                      setupdateData({ ...rowData });
                      setFormTrigger("theme");
                    }}
                  >
                    <EditTwoTone />
                  </IconButton>
                </Tooltip>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Delete">
                  <IconButton
                    className={classes.active}
                    disabled={rowData?.recordState.toUpperCase() === "ACTIVE"}
                    onClick={() => {
                      setOpenDeleteModal(rowData);
                    }}
                  >
                    <DeleteTwoTone />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          ),
      },
    ]);
  }, [categories]);

  useEffect(() => {
    runQueryAllThemes({
      variables: { searchBy: searchBy, first: rowsPerPage },
    });
  }, [formTrigger, searchBy, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
      runQueryAllThemes({
        variables: {
          first: rowsPerPage,
          after: endCursor,
          searchBy: searchBy,
        },
      });
    }
    if (newPage < page) {
      runQueryAllThemes({
        variables: {
          last: rowsPerPage,
          before: startCursor,
          searchBy: searchBy,
        },
      });
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    let newRowsPerPage = event?.target?.value
      ? parseInt(event.target.value)
      : 5;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  let updateCategoryFn = (rowData, state) => {
    setshowLoader(true);
    updateState({
      variables: {
        counsellingThemeId: rowData.idCounsellingTheme,
        newStatus: state,
      },
    })
      .then((response) => {
        setshowLoader(false);
        if (response?.errors) {
          let message = response?.errors[0]?.message;
          NotificationManager.warning(
            message ? message : "Error to update the category",
            "",
            5000
          );
        } else {
          if (state.toUpperCase() === "DELETED") {
            categories.splice(
              categories.findIndex(
                (f) => f.idCounsellingTheme === rowData.idCounsellingTheme
              ),
              1
            );
          } else {
            rowData.recordState = state;
            NotificationManager.success(
              "The state of the category is updated successfully ",
              "",
              5000
            );
          }
          setCategories([...categories]);
          setreloadRender(!reloadRender);
        }
      })
      .catch((e) => {
        setshowLoader(false);
        NotificationManager.warning(
          e?.message ? e.message : "Error to update the category",
          "",
          5000
        );
      });
  };

  let toggleChecked = (rowData) => {
    updateCategoryFn(
      rowData,
      rowData.recordState.toUpperCase() === "ACTIVE" ? "INACTIVE" : "ACTIVE"
    );
  };

  let deleteSurvey = (rowData) => {
    updateCategoryFn(rowData, "DELETED");
    setOpenDeleteModal(null);
  };

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.idCounsellingTheme);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this category?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteSurvey}
      />
    ) : null;
  };

  const tablePaginationListView = (props) => {
    const computedProps = { ...props };
    computedProps.style = {
      ...(computedProps?.style ?? {}),
      borderBottom: "0px",
    };
    return (
      <>
        <div style={{ display: "flex" }}>
          <div
            style={{
              display: "flex",
              width: "95%",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            {user && (
              <TableConvention>
                <div
                  style={{
                    background: "rgba(191, 191, 191, 1)",
                    height: "1em",
                    width: "1em",
                    borderRadius: "7px",
                  }}
                ></div>
                <p>Disable</p>
                <div
                  style={{
                    background: "rgba(4, 180, 105, 1)",
                    height: "1em",
                    width: "1em",
                    borderRadius: "7px",
                  }}
                ></div>
                <p>Active</p>
              </TableConvention>
            )}
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <table>
              <tbody>
                <tr>
                  <TablePagination {...computedProps} />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  return (
    <GeneralStyleSurveyCategory>
      {error && (
        <Row>
          <Col md="12" className="d-flex justify-content-center mt-5">
            {loading ? <PointersLine color={themeConfig.text.primary} /> : null}
            {error ? <h1>Error :(</h1> : null}
          </Col>
        </Row>
      )}

      {!loading && !showCards ? (
        <MaterialTable
          style={{ boxShadow: "none", marginLeft: "24px", marginRight: "20px" }}
          title=""
          columns={columnThemeCategories}
          data={categories}
          options={{
            toolbar: false,
            paging: false,
            search: false,
            maxBodyHeight: 450,
            headerStyle: {
              zIndex: 1,
              fontWeight: "bold",
            },
            cellStyle: {
              padding: "5px 10px",
            },
          }}
        />
      ) : null}
      {showCards && (
        <>
          <ViewControlMenu
            identity={"theme-categories"}
            title={""}
            showCards={showCards}
            setShowCards={setShowCards}
            list={categories}
            toggleChecked={toggleChecked}
            handleClickActions={handleClickActions}
            anchorSelected={anchorSelected}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            setAnchorSelected={setAnchorSelected}
            setOpenDeleteModal={setOpenDeleteModal}
            setupdateData={setupdateData}
            triggerValue={"theme"}
            setFormTrigger={setFormTrigger}
            isAgent={false}
          />
        </>
      )}
      {categories.length === 0 ? <NoRecord /> : null}
      <div style={{ display: "flex" }}>
        <div
          style={{
            display: "flex",
            width: "95%",
            justifyContent: "flex-start",
            alignItems: "center",
            marginLeft: "1.5rem",
          }}
        >
          {user && (
            <TableConvention>
              <div
                style={{
                  background: "rgba(191, 191, 191, 1)",
                  height: "1em",
                  width: "1em",
                  borderRadius: "7px",
                }}
              ></div>
              <p>Disable</p>
              <div
                style={{
                  background: "rgba(4, 180, 105, 1)",
                  height: "1em",
                  width: "1em",
                  borderRadius: "7px",
                }}
              ></div>
              <p>Active</p>
            </TableConvention>
          )}
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <TablePagination
            component="div"
            style={{ display: "flex", justifyContent: "center" }}
            count={allPages}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>

      {showDeleteModal()}
      {(showLoader || loading) && (
        <PortalModal>
          <ContentLoaderSurveyCategory>
            <PointersLine color={themeConfig.text.primary}></PointersLine>
          </ContentLoaderSurveyCategory>
        </PortalModal>
      )}
    </GeneralStyleSurveyCategory>
  );
};
export default ThemeCategories;
